module.exports = __webpack_public_path__ + "static/media/nexuses-02.2bfb874f.png";